import React from 'react';
import { Tab, Tabs } from 'react-bootstrap';
import './CurveEditor.scss';
import { Curve } from 'curves';
import CurveSettingsEditor from './CurveSettingsEditor/CurveSettingsEditor';
import { DisplayOptions } from '../CurveDisplay/CurveDisplay';
import KeyframeEditor from './KeyframeEditor/KeyframeEditor';
import { KeyframeValueInputProps } from './KeyframeEditor/KeyframeValueInput/KeyframeValueInput';
import ModifierEditor from './ModifierEditor/ModifierEditor';
import { ModifierCurveType } from './ModifierCurveType';
import CodeEditor from './CodeEditor/CodeEditor';

interface CurveEditorProps<T> {
    curve: React.RefObject<Curve<T>>;
    displayOptions: DisplayOptions;
    onUpdate: (opts?: DisplayOptions)=>void;
    modifierType?: ModifierCurveType;
    valueInput: (props: KeyframeValueInputProps<T>) => React.ReactElement; // eslint-disable-line react/no-unused-prop-types
}

function CurveEditor<T>(props: CurveEditorProps<T>): React.ReactElement {
  return (
    <div className="tab-container">
      <Tabs defaultActiveKey="keyframe" id="curve-editor">
        <Tab eventKey="keyframe" title="Keyframes" className="tab-content">
          <KeyframeEditor
            curve={props.curve}
            valueInput={props.valueInput}
            onUpdate={props.onUpdate}
          />
        </Tab>
        <Tab eventKey="modifiers" title="Modifiers" className="tab-content">
          <ModifierEditor<T>
            curve={props.curve}
            modifierType={props.modifierType}
            onUpdate={props.onUpdate}
          />
        </Tab>
        <Tab eventKey="curve" title="Curve & Display" className="tab-content">
          <CurveSettingsEditor<T>
            curve={props.curve}
            displayOptions={props.displayOptions}
            onUpdate={props.onUpdate}
          />
        </Tab>
        <Tab eventKey="code" title="Code" className="tab-content">
          <CodeEditor<T>
            curve={props.curve}
            modifierType={props.modifierType}
          />
        </Tab>
      </Tabs>
    </div>
  );
}

export default CurveEditor;
